module.exports = __webpack_public_path__ + "img/lesson.3aae9c69.jpg";